import { ENV } from '../config/ENV';

export const apiBaseUrl = ENV.API_BASE_URL;
export const DEFAULT_FROM_DATE = ENV.DEFAULT_FROM_DATE;
